import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuxiliarService } from './../../auxiliar.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  server: string = '';

  constructor(public router: Router, private httpClient: HttpClient, private auxService: AuxiliarService) {
    this.server = this.auxService.getServidor();
  }

  register(name: string, surname: string, password: string, passwordVerify: string) {

  }

  login(email: string, password: string){
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    return this.httpClient.post(this.server+"/api/login", formData);
  }

  logout() {
    localStorage.setItem('appAuthToken', '');
    localStorage.setItem('appAuthType', '');
    localStorage.setItem('appUserName', '');
    localStorage.setItem('expires_at', '');
    localStorage.setItem('appAuthRol', '');
    localStorage.setItem('appUserSurname', '');
    localStorage.setItem('appUserEmail', '');
    localStorage.setItem('appUserID', '');
    localStorage.setItem('appUserActive', '');
    this.router.navigateByUrl('/login');
  }

  recover(email: string){
    const formData = new FormData();
    formData.append('email', email);
    return this.httpClient.post(this.server+"/api/recover", formData);
  }

  changePassword(password: string, password2: string, token: string) {
    const formData = new FormData();
    formData.append('password', password);
    formData.append('password2', password2);
    formData.append('token', token);
    return this.httpClient.post(this.server+"/api/changepassword", formData);
  }

  getToken() {
    return (localStorage.getItem('appAuthToken') || "");
  }

  isLogged(){
    var now = new Date();
    var expirationTime = new Date(localStorage.getItem('expires_at'));
    if(now < expirationTime && (this.getToken().trim() !== "")){ return true; }else{ return false; }
  }

  userRol(){
    return (localStorage.getItem('appAuthRol') || "");
  }

  userRolCheck(permission: string){
    var permissions = JSON.parse((localStorage.getItem('permission') || '{}'));
    var allowed = false;
    if(permissions[permission] === 'true'){
      allowed = true;
    }
    return allowed;
  }

  canAccessContenedores(): boolean {
    return this.userRolCheck('permiso_contenedores')
      || this.userRolCheck('permiso_contenedores_alta_movimientos')
      || this.userRolCheck('permiso_contenedores_alta_mantenimientos');
  }

  hasFullContenedoresAccess(): boolean {
    return this.userRolCheck('permiso_contenedores');
  }

  canAltaMovimiento(): boolean {
    return this.userRolCheck('permiso_contenedores_alta_movimientos');
  }

  canAltaMantenimiento(): boolean {
    return this.userRolCheck('permiso_contenedores_alta_mantenimientos');
  }

  canViewMovimientos(): boolean {
    return this.hasFullContenedoresAccess();
  }

  canViewMantenimientos(): boolean {
    return this.hasFullContenedoresAccess();
  }

  userEmail(): string {
    return (localStorage.getItem('appUserEmail') || '').trim();
  }

  canAccessSocketDiagnostico(): boolean {
    return this.userEmail().toLowerCase() === 'programacion@mitsinformatica.com';
  }

}
